<template>
    <div class="client-content">
        <div class="header-top">
            <div class="toggle-button-steps">
                <button
                    @click="onToggleShowPanelElements"
                    class="btn-toggle-elements-panel"
                    :class="{ open: showPanelElements }"
                >
                    <img
                        :src="iconButtonShowPanel"
                        loading="lazy"
                        alt=""
                    />
                </button>

                <div class="steps flex">
                    <a
                        :href="complectationRoute"
                        class="item-steps flex items-center"
                        :class="{ active: $route.name == 'index' }"
                    >
                        <div class="icon">
                            <img
                                src="/images/client/steps/9_shag-1.svg"
                                loading="lazy"
                                alt=""
                            />
                        </div>
                        <div class="txt">
                            <span>{{ $t("client.index.step_1_1") }}</span>
                        </div>
                    </a>
                    <a
                        :href="engravingRoute"
                        class="item-steps flex items-center"
                        :class="{ active: $route.name == 'engraving' }"
                        v-if="settings.use_engraving"
                    >
                        <div class="icon">
                            <img
                                src="/images/client/steps/10_shag-2.svg"
                                loading="lazy"
                                alt=""
                            />
                        </div>
                        <div class="txt">
                            <span>{{ $t("client.index.step_2_2") }}</span>
                        </div>
                    </a>
                </div>
            </div>

            <button
                @click="showPanelSetting = !showPanelSetting"
                class="btn-toggle-setting-panel"
                :class="{ open: showPanelSetting }"
                >
                <img
                    :src="iconToggleSetting"
                    loading="lazy"
                    alt=""
                />
            </button>

            <div class="top__icons" :class="{ open: showPanelSetting }">
                <div
                    v-if="settings.show_info_pages"
                    class="top__icons-item"
                    :class="{ active: lowPerformance }"
                >
                    <button
                        class="top__icons-button"
                        @click="onChangeShowInfo"
                        :class="{ active: showInfo }"
                        >
                        <img
                            src="/images/design/icon-info-menu.svg"
                            loading="lazy"
                            alt="Информация"
                        />
                    </button>
                    <div class="top__icons-hint">Информация</div>
                </div>
                <div
                    v-if="
                        settings.show_performance_regim == 1 &&
                        $route.name !== 'engraving'
                    "
                    class="top__icons-item"
                    :class="{ active: lowPerformance }"
                >
                    <button
                        class="top__icons-button"
                        @click="changePerformance"
                        :class="{ active: lowPerformance }"
                        >
                        <img
                            src="/images/design/icon-top-proizvoditelnost.svg"
                            loading="lazy"
                            alt="Производительность"
                        />
                    </button>
                    <div class="top__icons-hint">Производительность</div>
                </div>
                <div
                    v-if="settings.show_link_to_video_instruction == 1"
                    class="top__icons-item"
                    :class="{ active: showVideos }"
                >
                    <button
                        @click="showingVideos"
                        class="top__icons-button"
                        :class="{ active: showVideos }"
                    >
                    <img
                        src="/images/design/icon-top-videoinstrukciya.svg"
                        loading="lazy"
                        alt="Видеоинструкция"
                    />
                    </button>
                    <div class="top__icons-hint">Видеоинструкция</div>
                </div>
                <div
                    v-if="settings.show_contacts_block == 1"
                    class="top__icons-item"
                    :class="{ active: showContacts }"
                >
                    <button
                        class="top__icons-button"
                        @click="showingContacts"
                        :class="{ active: showContacts }"
                    >
                    <img
                        src="/images/design/icon-top-kontakty.svg"
                        loading="lazy"
                        alt="Контакты"
                    />
                    </button>
                    <div class="top__icons-hint">Контакты</div>
                </div>
                <div
                    v-if="
                        settings.show_change_env == 1 &&
                        $route.name !== 'engraving'
                    "
                    class="top__icons-item"
                    :class="{ active: noShowSceneEnv }"
                >
                    <button
                        class="top__icons-button"
                        @click="changeEnv"
                        :class="{ active: noShowSceneEnv }"
                    >
                    <img
                        src="/images/design/icon-top-vkl-vykl-fon.svg"
                        loading="lazy"
                        alt="Вкл./Выкл. фон"
                    />
                    </button>
                    <div class="top__icons-hint">Вкл./Выкл. фон</div>
                </div>
                <div class="top__icons-item">
                    <a
                        :href="settings.link_to_site_for_client"
                        class="top__icons-button"
                        :target="settings.target_link_to_site_for_client"
                        ><img
                            src="/images/design/icon-top-link-sait.svg"
                            loading="lazy"
                            alt="Вернуться на сайт"
                    /></a>
                    <div class="top__icons-hint">Вернуться на сайт</div>
                </div>
            </div>
            <div class="phone-cart">
                <InformerApproximatePrice class="informer-normal" />
                <InformerApproximatePrice
                    :additionalClass="'rb'"
                    class="informer-adaptive"
                />
                <div
                    class="client-cart-total"
                    @click="showComplectation = true"
                >
                    <div
                        class="client-cart-total__value"
                        v-if="
                            settings.show_informer &&
                            settings.with_calc_price == 1
                        "
                    >
                        {{ $toCurrency(total) }}
                    </div>

                    <button class="client-cart-total__button">
                        <img
                            src="/images/client/korzina.svg"
                            loading="lazy"
                            alt=""
                        />
                    </button>
                </div>
            </div>
        </div>

        <Complectation
            v-if="showComplectation"
            @close="showComplectation = false"
        />

        <router-view :key="$route.fullPath"></router-view>

        <contacts-modal
            v-if="showContacts && settings.show_contacts_block == 1"
            @close-modal="showContacts = false"
        />

        <video-instructions-modal
            v-if="showVideos && settings.show_link_to_video_instruction == 1"
            @close-modal="showVideos = false"
        />

        <UpdateModal v-if="platformUpdating" :client="true"></UpdateModal>
    </div>
</template>
<script>
import Complectation from "./Client/Complectation.vue";
import ContactsModal from "./Client/ContactsModal.vue";
import VideoInstructionsModal from "./Client/VideoInstructionsModal.vue";
import UpdateModal from "../components/Admin/Updates/UpdateModal";
export default {
    components: {
        Complectation,
        ContactsModal,
        VideoInstructionsModal,
        UpdateModal,
    },
    data() {
        return {
            showComplectation: false,
            showVideos: false,
            showContacts: false,
            showInfo: false,
            showPanelSetting: false,
        };
    },

    methods: {
        changePerformance() {
            this.$store.dispatch(
                "setLowPerformance",
                this.lowPerformance ? 0 : 1
            );
            location.reload();
        },
        showingVideos() {
            this.showVideos = !this.showVideos;
        },
        showingContacts() {
            this.showContacts = !this.showContacts;
        },
        changeEnv() {
            this.$store.dispatch(
                "setNoShowSceneEnv",
                this.noShowSceneEnv ? 0 : 1
            );
            location.reload();
        },
        onChangeShowInfo() {
            if (this.showInfo) {
                this.$store.dispatch("clientMain/setManageElement", null);
            } else {
                this.$store.dispatch("clientMain/setManageElement", "pages");
            }
            this.showInfo = !this.showInfo;
        },
        onToggleShowPanelElements() {
            this.$store.dispatch(
                "clientMain/setShowPanelElements",
                !this.showPanelElements
            );
        },
    },
    computed: {
        noShowSceneEnv() {
            return this.$store.state.noShowSceneEnv;
        },
        lowPerformance() {
            return this.$store.state.lowPerformance;
        },
        platformUpdating() {
            return this.$store.state.versions.updatingProgress &&
                this.$store.state.versions.updatingProgress.processing &&
                parseInt(
                    this.$store.state.versions.updatingProgress.processing
                ) === 1
                ? true
                : false;
        },
        settings() {
            return this.$store.state.settings.settings;
        },
        total() {
            return this.$store.state.clientOrder.total;
        },
        engravingRoute() {
            let route = "/engraving";

            if (this.$route.query && this.$route.query.order_cache) {
                route += `?order_cache=${this.$route.query.order_cache}`;
            }
            return route;
        },
        complectationRoute() {
            let route = "/";

            if (this.$route.query && this.$route.query.order_cache) {
                route += `?order_cache=${this.$route.query.order_cache}`;
            }
            return route;
        },
        manageElement() {
            return this.$store.state.clientMain.manageElement;
        },
        showPanelElements() {
            return this.$store.state.clientMain.showPanelElements;
        },
        iconButtonShowPanel() {
            return this.showPanelElements
                ? "/images/icons/adaptive-menu-white.svg"
                : "/images/icons/adaptive-menu-black.svg";
        },
        iconToggleSetting() {
            return this.showPanelSetting
                ? "/images/icons/adaptive-parametry-white.svg"
                : "/images/icons/adaptive-parametry-black.svg";
        },
    },
    watch: {
        manageElement(newVal) {
            if (newVal !== "pages") {
                this.showInfo = false;
            }
        },
    },
};
</script>
<style scoped>
.header-top {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1;
}
.btn-toggle-elements-panel,
.btn-toggle-setting-panel {
    display: none;
}
.informer-adaptive {
    display: none;
    visibility: hidden;
    width: 0;
}
.toggle-button-steps {
    display: flex;
}
.top__icons {
    display: flex;
}
.top__icons-item {
    width: 55px;
    position: relative;
    z-index: 0;
}
.top__icons-item + .top__icons-item {
    border-left: 1px solid #dfdfdf;
}

.top__icons-item.active,
.top__icons-item.active + .top__icons-item {
    border-color: #10b981;
}

.top__icons-button {
    display: block;
    height: 100%;
    padding: 10px;
    opacity: 0.7;
    transition: all 0.2s;
}
.top__icons-button.active {
    background-color: #10b981;
}
.top__icons-button.active .fil0 {
    fill: #fff;
}
.top__icons-hint {
    top: calc(100% + 6px);
    position: absolute;
    background-color: #172935;
    color: #fff;
    font-size: 12px;
    padding: 5px 7px;
    left: 50%;
    transform: translateX(-50%);
    display: none;
    opacity: 0;
    transition: all 0.2s;
    white-space: nowrap;
}
.top__icons-hint::before {
    content: "";
    position: absolute;
    top: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 6px 6px 6px;
    border-color: transparent transparent #172935 transparent;
}

.top__icons-item:hover .top__icons-button,
.top__icons-item.active .top__icons-button {
    opacity: 1;
}

.top__icons-item:hover .top__icons-hint {
    display: block;
    opacity: 1;
}
.client-content {
    display: grid;
    grid-template-rows: 55px auto;
    width: 100%;
    height: 100vh;
}

.client-cart-total {
    display: flex;
    height: 100%;
    cursor: pointer;
}
.client-cart-total > div {
    display: grid;
    place-content: center;
    padding-left: 15px;
    padding-right: 15px;
}
.client-cart-total__value {
    background-color: #172935;
    color: #fff;
    font-weight: 400;
    font-size: 24px;
}

.client-cart-total__button {
    width: 50px;
    height: 100%;
    background-color: #c31818;
    display: grid;
    place-content: center;
}
.phone-cart {
    display: flex;
    column-gap: 10px;
    height: 100%;
    align-items: center;
}

@media screen and (max-width: 1000px) {
    .client-content {
        grid-template-rows: 40px auto;
    }
    .btn-toggle-elements-panel,
    .btn-toggle-setting-panel {
        display: grid;
        place-items: center;
        height: 40px;
        width: 40px;
        background-color: #d9d9d9;
        padding: 10px;
    }
    .btn-toggle-elements-panel.open,
    .btn-toggle-setting-panel.open {
        background-color: #172935;
    }
    .item-steps {
        padding: 0 7px;
    }
    .phone-cart {
        position: fixed;
        z-index: 20;
        bottom: 0;
        height: 40px;
        width: 100%;
        justify-content: flex-end;
        background: #172935;
        column-gap: 0;
    }
    .informer-adaptive {
        display: block;
        visibility: visible;
        width: auto;
    }
    .informer-normal {
        visibility: hidden;
    }

    .top__icons {
        position: fixed;
        z-index: 10;
        top: 40px;
        right: -9999px;
        flex-direction: column;
        height: 100%;
        background-color: #fff;
    }
    .top__icons-item + .top__icons-item {
        border-left: none;
        border-top: 1px solid #dedede;
    }
    .top__icons.open {
        right: 0;
    }

    .item-steps .icon {
        width: 22px;
        height: 22px;
    }

    .item-steps .txt {
        font-size: 13px;
        line-height: 1;
    }
}
@media screen and (max-width: 600px) {
    .item-steps .txt {
        display: none;
    }
}
</style>
